<template>
    <div 
        class="search-order-container"
    >
        <span class="search-order-title">
            {{ sortOrder.name }}
        </span>
        <a-button 
            v-on:click="stepSortOrder"
            :type="sortOrder.order === '' ? 'default' : 'primary'"
            :icon="sortOrder.order === 'ascend' ? 'up' : 'down'"
        />
    </div>
</template>

<script>
export default {
    props: {
        sort: {
            name: String,
            order: String // 'ascend' || 'descend' || null
        }
    },

    model: {
        prop: 'sort',
        event: 'orderChange'
    },

    data() {
        return {
            orderSteps: [
                '',
                'ascend',
                'descend'
            ]
        }
    },

    computed: {
        sortOrder: {
            get() {
                return this.sort;
            },
            set(val) {
                this.$emit('orderChange', val);
            }
        },
    },

    methods: {
        stepSortOrder() {
            const currentIx = this.orderSteps.findIndex(el => this.sortOrder.order === el);
            let nextOrder;
            if (currentIx + 1 === this.orderSteps.length) {
                nextOrder = this.orderSteps[0];
            } else {
                nextOrder = this.orderSteps[currentIx + 1];
            }
            this.sortOrder = {
                name: this.sort.name,
                order: nextOrder
            }
        }
    }


}
</script>

<style lang="scss" scoped>
    .search-order-container {
        margin-left: 10px;
        margin-right: 10px;
    }
    .search-order-title {
        font-weight: bold;
    }
</style>